export const PENDING_STATUS = 'pending'
export const SUCCESS_STATUS = 'success'
export const FAILURE_STATUS = 'failure'

export const PENDING = 'pending'
export const SUCCESS = 'success'
export const FAILURE = 'failure'


// WEBPACK FOOTER //
// ./src/constants.js